import { useState } from "react";
import useDeviceType from "../../Utiles/FindDevice";

const Button = ({ 
  text, 
  onClick, 
  disabled = false, 
  loading = false, 
  type = "button",
  className = "",
  ...props 
}) => {
  const deviceType = useDeviceType();

  const handleClick = async (e) => {
    if (onClick && !disabled && !loading) {
      await onClick(e);
    }
  };

  return (
    <>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        .animate-spin {
          animation: spin 1s linear infinite;
        }
        .button-transition {
          transition: all 0.3s ease-in-out;
        }
      `}</style>

      <button
        type={type}
        onClick={handleClick}
        disabled={disabled || loading}
        className={`
          bg-[#0081F8] hover:bg-[#0071e8] 
          disabled:bg-gray-400 disabled:cursor-not-allowed 
          text-white rounded-full 
          transition-all duration-200 ease-in-out
          font-medium
          flex items-center justify-center
          button-transition
          ${loading 
            ? `${deviceType === "mobile" ? "w-8 h-8 min-w-[32px]" : "w-12 h-12 min-w-[48px]"} px-0` 
            : `${deviceType === "mobile" 
                ? "px-6 py-2 text-[13px]" 
                : "py-3 px-8 text-[16px]"
              }`
          }
          ${className}
        `}
        {...props}
      >
        {loading ? (
          <div className={`
            border-2 border-white border-t-transparent 
            rounded-full animate-spin
            ${deviceType === "mobile" ? "w-4 h-4" : "w-6 h-6"}
          `} />
        ) : (
          text
        )}
      </button>
    </>
  );
};

export default Button;
